module.exports = __webpack_public_path__ + "img/success.086b12ad.svg";